import { FC } from 'react'
import Style from './HeaderTabs.module.scss'
import { SVGs } from '../../../../assets'
import { Input } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
interface Props {
    onTabChangeHandler: (type: string) => void
    onLeaderBoardHandler?: () => void
    selectedTab: string
    selectedTime: string
    onSearchUserTag?: (value: string) => void
    onChangeSearchHandler: (value: string) => void
    onSearch: () => void
    isUserExist: boolean
    searchText: string
}

export const HeaderTabs: FC<Props> = ({
    onTabChangeHandler,
    selectedTab,
    selectedTime,
    onChangeSearchHandler,
    onSearch,
    isUserExist,
    searchText,
}) => {
    const onChangeSearchDebounceHandler = (e: any) => {
        const value = e.target.value
        onChangeSearchHandler(value)
    }
    return (
        <div className={Style.container}>
            <div className={Style.leftButtonWrapper}>
                <div
                    onClick={() => onTabChangeHandler('top100')}
                    className={
                        selectedTab !== 'top100'
                            ? Style.leftButtonAllTime
                            : Style.leftButtonAllTimeActive
                    }
                    // style={{
                    //     backgroundColor:
                    //         selectedTab === 'top100'
                    //             ? '#10F48B'
                    //             : 'rgba(19, 19, 44, 1)',
                    //     color:
                    //         selectedTab === 'top100'
                    //             ? 'rgba(27, 26, 24, 1)'
                    //             : 'rgba(255, 255, 255, 0.75)',
                    //     fontWeight: selectedTab === 'top100' ? '700' : '400',
                    // }}
                >
                    <p> Top 100</p>
                </div>
                {isUserExist ? (
                    <div
                        onClick={() => onTabChangeHandler('myRanking')}
                        className={
                            selectedTab !== 'myRanking'
                                ? Style.leftButtonMonthly
                                : Style.leftButtonMonthlyActive
                        }
                        // style={{
                        //     fontWeight:
                        //         selectedTab === 'myRanking' ? '700' : '400',
                        //     backgroundColor:
                        //         selectedTab === 'myRanking'
                        //             ? '#10F48B'
                        //             : 'rgba(19, 19, 44, 1)',
                        //     color:
                        //         selectedTab === 'myRanking'
                        //             ? 'rgba(27, 26, 24, 1)'
                        //             : 'rgba(255, 255, 255, 0.75)',
                        // }}
                    >
                        My Ranking
                    </div>
                ) : null}

                {selectedTime === 'monthly' ? (
                    <div
                        onClick={() => onTabChangeHandler('hallOfFame')}
                        className={
                            selectedTab !== 'hallOfFame'
                                ? Style.leftButtonHallOfFame
                                : Style.leftButtonHallOfFameActive
                        }
                        // style={{
                        //     fontWeight:
                        //         selectedTab === 'hallOfFame' ? '700' : '400',
                        //     backgroundColor:
                        //         selectedTab === 'hallOfFame'
                        //             ? '#10F48B'
                        //             : 'rgba(19, 19, 44, 1)',
                        //     color:
                        //         selectedTab === 'hallOfFame'
                        //             ? 'rgba(27, 26, 24, 1)'
                        //             : 'rgba(255, 255, 255, 0.75)',
                        // }}
                    >
                        Hall of Fame
                    </div>
                ) : null}
            </div>

            <div className={Style.searchWrapper}>
                {selectedTab === 'myRanking' ? (
                    <div className={Style.searchContainer}>
                        <Input
                            allowClear={{
                                clearIcon: (
                                    <CloseOutlined
                                        style={{ color: '#FFFFFF' }}
                                    />
                                ),
                            }}
                            placeholder="Search Challenger"
                            onChange={onChangeSearchDebounceHandler}
                            value={searchText}
                            prefix={
                                <img
                                    src={SVGs.searchIcon}
                                    alt="selected_icon"
                                    width={16}
                                    height={18}
                                    onClick={onSearch}
                                />
                            }
                        />
                    </div>
                ) : null}
            </div>
            {/* <div
                className={Style.leaderTraderButton}
                onClick={onLeaderBoardHandler}
            >
                Lead Trader
            </div> */}
        </div>
    )
}
